import styles from './paging.scss';
import { LoadMore } from './loadMore';
import { PagePicker } from './pagePicker';
import { ProgressBar } from './progressBar';
import { Section } from 'components/Section';
import cn from 'classnames';

interface PagingProps {
  className?: string;
  totalItems?: number;
  visible?: number;
  currentPage: number;
  amountOfPages: number;
  gotoNextPage: () => Promise<void>;
  gotoPrevPage: () => Promise<void>;
  gotoPage: (page: number) => Promise<void>;
  showMore?: () => Promise<void>;
  showLoadMore: boolean;
  showPagePicker: boolean;
  showProgressBar: boolean;
  rootCategoryUrl: string;
  loadMoreButtonText?: string;
  progressBarText?: string;
  progressBarDoneText?: string;
  loadMoreUrl?: string;
  showLoading?: boolean;
  isCustomerPage?: boolean;
}

export const Paging = ({
  totalItems,
  visible,
  showMore,
  loadMoreUrl,
  amountOfPages,
  gotoNextPage,
  gotoPrevPage,
  gotoPage,
  rootCategoryUrl,
  showPagePicker,
  showLoadMore,
  showProgressBar,
  currentPage,
  progressBarText,
  progressBarDoneText,
  loadMoreButtonText,
  showLoading = true,
  isCustomerPage = false
}: PagingProps) => (
  <Section
    theme={{ surface: 'transparent' }}
    contentClassName={cn(styles.paging, {
      [styles.customerPage]: isCustomerPage
    })}
  >
    {showProgressBar && (
      <ProgressBar
        className={styles.progressBar}
        total={totalItems || 0}
        visible={visible || 0}
        hasSeenAllProducts={!showLoadMore}
        progressBarText={progressBarText || ''}
        progressBarDoneText={progressBarDoneText || ''}
      />
    )}

    {showLoadMore && showMore && (
      <LoadMore
        className={styles.loadMore}
        showMoreProducts={showMore}
        nextPageUrl={loadMoreUrl}
        loadMoreButtonText={loadMoreButtonText || ''}
      />
    )}

    {showPagePicker && (
      <PagePicker
        className={cn(styles.pagePicker, {
          [styles.customerPage]: isCustomerPage
        })}
        pageNbr={currentPage}
        nbrOfPages={amountOfPages}
        nextPage={gotoNextPage}
        prevPage={gotoPrevPage}
        gotoPage={gotoPage}
        rootCategoryUrl={rootCategoryUrl}
        showLoading={showLoading}
      />
    )}
  </Section>
);
